/**
 * 案例相关API
 */
import request from '@/utils/request'

// 获取案例列表
export function getCasesList(params) {
  return request({
    url: 'studies/caseStudies/list',
    method: 'get',
    params
  })
}

// 根据分类获取案例
export function getCasesByCategory(category) {
  return request({
    url: 'studies/caseStudies/category',
    method: 'get',
    params: { category }
  })
}

// 获取案例详情
export function getCaseDetail(id) {
  return request({
    url: `studies/caseStudies/${id}`,
    method: 'get'
  })
}

// 创建案例（后台管理用）
export function createCase(data) {
  return request({
    url: 'studies/caseStudies',
    method: 'post',
    data
  })
}

// 更新案例（后台管理用）
export function updateCase(id, data) {
  return request({
    url: `studies/caseStudies/${id}`,
    method: 'put',
    data
  })
}

// 删除案例（后台管理用）
export function deleteCase(id) {
  return request({
    url: `studies/caseStudies/${id}`,
    method: 'delete'
  })
}
